<template>
    <div style="display: flex; flex-direction: column;">
        <MercenaryHeader :title="'자세히 보기'" :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <div style="flex: 1; background-color: #f5f5f5;">
            <div style="margin-top: 80px; text-align: center;">
                <div style="font-weight: 500;line-height: 24px;">{{ payInfo.refund === IS_REFUND.REFUND ? '결제가 취소된 내역입니다.' : '결제완료' }}</div>
                <div style="font-size: 24px;font-weight: 700;line-height: 34px; color: var(--color-main);">{{ payInfo.settle_price | comma }} 원</div>
            </div>
            <div style="padding: 0 12px; margin-top: 16px;">
                <div style="padding: 16px; background-color: #fff; border-radius: 12px;">
                    <div style="display: flex; justify-content: space-between; font-size: 14px;font-weight: 500; padding-bottom: 12px; border-bottom: 1px solid #ededed;">
                        <div style="color: #808080;">결제수단</div>
                        <div>{{ payInfo.bank_name }}</div>
                    </div>
                    <div style="display: flex; justify-content: space-between; font-size: 14px;font-weight: 500; padding: 12px 0; border-bottom: 1px solid #ededed;">
                        <div style="color: #808080;">결제일자</div>
                        <div>{{ payInfo.insert_date.split('.')[0].replaceAll('-', '.') }}</div>
                    </div>
                    <div style="display: flex; justify-content: space-between; font-size: 14px;font-weight: 500; padding-top: 12px;">
                        <div style="color: #808080;">결제정보</div>
                        <div>{{ payInfo.contents }}</div>
                    </div>
                </div>
            </div>
            <div v-if="payInfo.refund === IS_REFUND.REFUND" style="margin-top: 8px; padding: 0 12px; padding-left: 20px;">
                <div style="display: flex; align-items: center; gap: 6px;">
                    <div style="height: 3px; width: 3px; background-color: #210f03; border-radius: 50%;"></div>
                    <div style="font-weight: 500; font-size: 12px; line-height: 20px; ">카드사에 따라 결제 금액에 대한 환불은 2~3일 소요될 수 있습니다.</div>
                </div>
                <div style="display: flex; align-items: center; gap: 6px;">
                    <div style="height: 3px; width: 3px; background-color: #210f03; border-radius: 50%;"></div>
                    <div style="font-weight: 500; font-size: 12px; line-height: 20px; ">2~3일 후에도 환불이 되지 않을 시 카드사에 문의바랍니다.</div>
                </div>
                <div style="display: flex; gap: 6px;">
                    <div style="height: 3px; width: 3px; background-color: #210f03; border-radius: 50%; margin-top: 9px; flex-shrink: 0;"></div>
                    <div style="font-weight: 500; font-size: 12px; line-height: 20px; ">환불 받을 금액이 정확하지 않을 경우 경과 시간에 따라 환불 금액이 달라질 수 있기 때문이며, <span style="font-weight: 700;">참여 취소 및 환불 규정</span>을 확인하시기 바랍니다.</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MercenaryHeader from "@/components/common/MercenaryHeader";

const IS_REFUND = {
    REFUND: '1',
    NO_REFUND: '0'
}

export default {
    name: 'PaymentDetail',
    components: { MercenaryHeader },
    props: {
        payInfo: {
            type: Object,
            default: () => { }
        },
        completeAction: {
            type: Function,
            default: () => { }
        }
    },
    data() {
        return {
            payMethod: null,
            IS_REFUND: IS_REFUND
        }
    },
    created() {

    }
}
</script>

<style scoped></style>